import { useNuxtApp } from "nuxt/app";
export function useLog(subSpace) {
  const log = useNuxtApp().$log;
  if (subSpace && log) {
    return log.space(subSpace);
  }
  return log;
}
